<vi-card data-at-dialog id="periods-dialog" [dialog]="true">
  <div *ngIf="dataDialog.dayIds.length === 1; else multiDayTitle" title>
    <h3 class="title flex-[100%] max-w-[100%]">
      {{ '+SCHEDULES.COMMON.EDIT_SCHEDULE_FOR' | translate }} {{ ' ' + days[dataDialog.dayIds[0]] }}
    </h3>
  </div>
  <ng-template #multiDayTitle>
    <div title class="periods-header flex flex-row flex-wrap">
      <h3 class="title flex-[100%] max-w-[100%]">
        {{ '+SCHEDULES.COMMON.EDIT_SCHEDULE_FOR' | translate }}
      </h3>
      <div class="days flex flex-col flex-[100%] max-w-[100%]">
        <div class="flex-1">
          <span *ngFor="let dayId of dataDialog.dayIds; let idx = index" class="day-item">
            <span *ngIf="addAnd(idx)"> {{ '+SCHEDULES.COMMON.AND' | translate }} </span>
            <span class="day">{{ days[dayId] }}</span>
            <span *ngIf="addComma(idx)">, </span>
          </span>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-container body data-at-body>
    <div content>
      <app-device-time-warning *ngIf="offSetDeviceTime$ | async"></app-device-time-warning>
      <ng-container *ngFor="let period of periods; let idx = index">
        <app-program-period
          *ngIf="period.mode !== scheduleService.defaultMode"
          id="period-{{ idx }}"
          [programs]="programs$ | async"
          [period]="period"
          [resolution]="resolution"
          [maxEntries]="maxEntries"
          (startChange)="onStartTimeChange($event)"
          (endChange)="onEndTimeChange($event)"
          (programChange)="onProgramChange($event)"
        >
          <button
            mat-icon-button
            gtm="onProgramRemove"
            class="delete-period-btn"
            id="delete-period-btn-{{ idx }}"
            [disabled]="!canDelete(period)"
            (click)="onDelete(period)"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </app-program-period>
      </ng-container>
      <ng-container *ngIf="isNewPeriod">
        <app-program-period
          class="new-period"
          id="new-period"
          [programs]="programs$ | async"
          [period]="newPeriod"
          (startChange)="onStartTimeChange($event, true)"
          (endChange)="onEndTimeChange($event, true)"
          (programChange)="onProgramChange($event, true)"
        >
          <button
            mat-icon-button
            gtm="onNewPeriodRemove"
            class="delete-period-btn"
            id="delete-new-period-btn"
            (click)="removeNewPeriod()"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </app-program-period>
      </ng-container>

      <app-banner *ngIf="maxEntriesOverflowAttempt" type="error">{{
        '+SCHEDULES.TIME_PHASES_LIMIT_REACHED_ERROR' | translate
      }}</app-banner>
      <app-banner *ngIf="canShowScheduleHintBox" type="info">{{ scheduleHintMessage }}</app-banner>

      <div class="flex flex-row flex-wrap justify-between items-center">
        <button
          data-at-time-schedule-btn-undo
          *ngIf="canUndo()"
          mat-button
          color="primary"
          gtm="onProgramUndo"
          id="undo-btn"
          (click)="onUndo()"
        >
          <mat-icon>undo</mat-icon>
          <span>{{ '+SCHEDULES.BUTTON.UNDO' | translate }}</span>
        </button>
        <button
          data-at-time-schedule-add-new-switching-time-btn
          class="btn-add-switching-time"
          *ngIf="canAddNewPeriod && !maxEntriesOverflowAttempt"
          mat-button
          color="primary"
          gtm="onAddProgram"
          id="add-new-period-btn"
          (click)="onAddNewPeriod()"
        >
          <mat-icon>add</mat-icon>
          <span>{{ '+SCHEDULES.BUTTON.ADD_NEW_PERIOD' | translate }}</span>
        </button>
      </div>
    </div>
  </ng-container>
  <div footer data-at-footer class="periods-footer flex flex-row gap-[10px] justify-end">
    <button
      data-at-cancel
      mat-button
      color="primary"
      gtm="onCancel"
      gtmAction="Schedule changes"
      gtmCategory="editSchedule"
      id="cancel-periods-btn"
      (click)="onCancel()"
    >
      {{ '+SCHEDULES.BUTTON.CANCEL' | translate }}
    </button>
    <button
      data-at-apply
      mat-raised-button
      color="primary"
      id="save-periods-btn"
      gtm="onSave"
      gtmAction="Schedule changes"
      gtmCategory="editSchedule"
      [disabled]="!canUndo() || isNewPeriod"
      (click)="onSave()"
    >
      {{ '+SCHEDULES.BUTTON.SAVE' | translate }}
    </button>
  </div>
</vi-card>
